"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InternalSettingsConfigContext = exports.InternalSettingsContext = void 0;
const react_1 = require("react");
exports.InternalSettingsContext = (0, react_1.createContext)({
    loadInternalSettings: () => Promise.resolve(),
    saveInternalSettings: () => Promise.resolve(),
    settingGroups: [],
    loading: false,
});
exports.InternalSettingsConfigContext = (0, react_1.createContext)({
    config: [],
});
//# sourceMappingURL=internal-settings-context.js.map